// M-165: 流入経路（最初の入口）の表示辞書。区分の定義・判定は shared の promoFirstSource.ts。
import {
  FIRST_SOURCE_BUCKETS,
  type FirstSourceBucket,
  type SegmentSpec,
} from '@kawai/shared';

export const FIRST_SOURCE_LABELS: Readonly<Record<FirstSourceBucket, string>> = {
  lineads: '広告 LP',
  poster: '店頭ポスター',
  event202611: '抽選券 QR',
  richmenu: 'リッチメニュー',
  other: '配信メッセージのリンク',
  none: '経路なし',
};

/** 分析サマリーの行の下に添える `?s=` の値（経路なしは説明文）。 */
export const FIRST_SOURCE_CODES: Readonly<Record<FirstSourceBucket, string>> = {
  lineads: 's=lineads',
  poster: 's=poster',
  event202611: 's=event202611',
  richmenu: 's=richmenu',
  other: 's= その他',
  none: '計測前の友だち・直接追加',
};

export const FIRST_SOURCE_OPTIONS: ReadonlyArray<{
  value: FirstSourceBucket;
  label: string;
}> = FIRST_SOURCE_BUCKETS.map((b) => ({
  value: b,
  label:
    b === 'none'
      ? `${FIRST_SOURCE_LABELS[b]}（${FIRST_SOURCE_CODES[b]}）`
      : b === 'other'
        ? FIRST_SOURCE_LABELS[b]
        : `${FIRST_SOURCE_LABELS[b]}（${b}）`,
}));

/** 条件の要約: 「流入経路=広告 LP（新規のみ）」/ 区分なしで新規のみなら「新規の友だちのみ」。 */
export function describeFirstSource(
  segment: Pick<SegmentSpec, 'firstSource' | 'firstSourceNewOnly'>,
): string | undefined {
  const newOnly = segment.firstSourceNewOnly === true;
  if (segment.firstSource) {
    return `流入経路=${FIRST_SOURCE_LABELS[segment.firstSource]}${newOnly ? '（新規のみ）' : ''}`;
  }
  return newOnly ? '新規の友だちのみ' : undefined;
}
